<template>
    <div>

        <el-row>
            <div class="left-justifying"><h3>绩效记录</h3></div>
        </el-row>

        <div class="panel">
            <div class="panel-body">

                <el-row>
                    <div class="advanced-search-location">
                        <AthubDropDownSearch :model="searchParams" :formWidth="800" v-if="true" size="mini" collapseTags
                                             multiple>
                            <el-form :model="searchParams" label-width="80px">
                                <el-row v-show="false" type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="数据中心">
                                            <dept-select size="mini" :allowAll="false"
                                                         :multiple="false" v-model="searchParams.kpiDto.deptid">
                                            </dept-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="开始月份">
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchParams.kpiDto.startdate"
                                                    type="month"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="结束月份">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="结束月份">
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchParams.kpiDto.enddate"
                                                    type="month"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="结束月份">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </AthubDropDownSearch>
                    </div>

                    <el-tabs v-model="activeTab">
                        <el-tab-pane label="" name="table_tab">
                            <el-row class="bottom20">
                                <el-table :data="kpiRecordPageInfo.tableData" stripe style="width: 100%">
                                    <el-table-column :formatter="formatDept" label="数据中心">
                                        <template slot="header" slot-scope="scope">
                                            数据中心<br>
                                            <dept-select size="mini"
                                                         :allowAll=false
                                                         :multiple=false
                                                         v-model="searchParams.kpiDto.deptid">
                                            </dept-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="realname" label="人员">
                                        <template slot="header" slot-scope="scope">
                                            人员<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="searchParams.realname"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="kpiDto.kpidate" :formatter="formatKpiDate" label="考评月份">
                                        <template slot="header" slot-scope="scope">
                                            考评月份<br><br><br>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="content" label="考评内容">
                                        <template slot="header" slot-scope="scope">
                                            考评内容<br><br><br>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="result" label="考评结果">
                                        <template slot="header" slot-scope="scope">
                                            考评结果<br><br><br>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="fileList" label="考评单">
                                        <template slot="header" slot-scope="scope">
                                            考评单<br><br><br>
                                        </template>
                                        <template slot-scope="scope">
                                            <template v-for="file in scope.row.fileList">
                                                <a :href="file.url">{{file.name}}</a><br>
                                            </template>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="score" label="绩效分">
                                        <template slot="header" slot-scope="scope">
                                            绩效分<br><br><br>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                </el-row>

                <el-row type="flex" class="row-bg" justify="end">
                    <el-pagination align="right" @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="currentPage"
                                   :page-sizes="pageSizes" :page-size="pageSize"
                                   layout="total, sizes, prev, pager, next, jumper"
                                   :total="kpiRecordPageInfo.total">
                    </el-pagination>
                </el-row>

            </div>
        </div>

    </div>
</template>

<script type="text/javascript">

    import DeptSelect from '@/components/dept'
    import AthubDropDownSearch from '@/components/common/athub.dropdown.search'
    import {debounce} from '../../util'
    import {createNamespacedHelpers, mapGetters} from 'vuex'
    import AthubCloudApi from "../../api/athubCloud";

    const kpiRecordNSHelper = createNamespacedHelpers( "kpiRecord" );
    const deptNSHelper = createNamespacedHelpers( "dept" );

    export default {
        name: 'kpiRecord',

        components: {

            DeptSelect,
            AthubDropDownSearch,

        },

        data() {

            return {

                searchParams: {
                    realname: '',
                    kpiDto: {
                        deptid: null,
                        startdate: '',
                        enddate: '',
                        status: 'CLOSE',
                    }
                },

                //表格翻页查询条件
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],

                //当前Tab页
                activeTab: "table_tab",

                deptInfoArr: [],

            }

        },

        methods: {

            ...kpiRecordNSHelper.mapActions([
                'getKpiRecordPageInfo',
            ]),

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTable();
            },

            async queryTable() {
                let pageParams = {
                    'currentPage': this.currentPage,
                    'pageSize': this.pageSize,
                }

                let deptInfo = await AthubCloudApi.fetchDeptListByAuthSites();
                let deptIds = deptInfo.map(e => e.id);

                let params = {
                    ...this.searchParams, ...pageParams
                };
                params.kpiDto.depts = deptIds;

                await this.getKpiRecordPageInfo(params);
            },

            formatKpiDate(row, column){
                return new Date(row.kpiDto.kpidate).Format('yyyy-MM');
            },

            formatDept(row, column) {
                let deptDesc = '';
                for (let i = 0; i < this.deptInfoArr.length; i++) {
                    if(row.kpiDto.deptid == this.deptInfoArr[i].id){
                        deptDesc = this.deptInfoArr[i].name;
                        return deptDesc;
                    }
                }
            },

        },

        computed: {
            ...kpiRecordNSHelper.mapGetters(['kpiRecordPageInfo']),
            ...deptNSHelper.mapGetters(['deptSource$']),
        },

        watch: {

            searchParams: {
                deep: true,
                handler: debounce(function (newVal, oldVal) {
                    this.currentPage = 1;
                    this.kpiRecordPageInfo.total = 0;
                    this.kpiRecordPageInfo.tableData = [];
                    this.queryTable();
                }, 500)
            },

        },

        mounted() {

            this.deptSource$.subscribe(v => {
                if (v != null && v.length > 0) {
                    this.searchParams.kpiDto.deptid = v[0].id;
                    this.deptInfoArr = v;
                }
            });

        },


    }

</script>